import React, { useCallback, useState } from 'react';

import { Colors } from '../../../../themes/colors';
import { Table } from '../../../commonComponents/Table/Table';
import { ROWS_PER_PAGE, useChallengeList } from '../hooks/useChallengeList';
import { properksChallengeColumn, properksChallengeConditionalRowStyles } from '../utils';
import CustomPortal from '../../../commonComponents/CustomPortal';

export const ProperksChallengeList = () => {
  const {
    data,
    isLoading,
    total,
    totalPages,
    handleTableChange,
    handleRelaunch,
    handleCancel,
    status,
    setStatus,
  } = useChallengeList();

  const [isShowCancelModal, setIsModalCancelModal] = useState(false);
  const [cancelId, setCancelId] = useState('');

  const handleOpenCancelModal = useCallback((id) => {
    setIsModalCancelModal(true);
    setCancelId(id);
  }, []);

  const getColumn = () =>
    properksChallengeColumn({
      onRelaunch: handleRelaunch,
      onCancel: handleOpenCancelModal,
    });

  const showFilterStatus = () => (
    <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: 16 }}>
      <span style={{ fontWeight: 'bold' }}>Status:</span>
      <select
        className="custom-select custom-select-lg"
        style={{ width: 154 }}
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option className="dropdown-item" value="all">
          All
        </option>
        <option className="dropdown-item" value="active">
          Active
        </option>
        <option className="dropdown-item" value="inactive">
          Inactive
        </option>
      </select>
    </div>
  );

  const renderDeleteChallengePopup = useCallback(() => {
    if (isShowCancelModal && cancelId) {
      return (
        <CustomPortal
          title="Are you sure you want to cancel this challenge?"
          rightButtonProps={{
            color: '#d9534f',
          }}
          submitText="Cancel"
          cancelText="Go Back"
          submitPressed={() => {
            handleCancel(cancelId);

            setIsModalCancelModal(false);
            setCancelId(null);
          }}
          cancelPressed={() => {
            setIsModalCancelModal(false);
            setCancelId(null);
          }}
        />
      );
    }

    return null;
  }, [cancelId, handleCancel, isShowCancelModal]);

  return (
    <div
      className="card mt-3 ml-3 mr-4 mb-3"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '85%',
        padding: '0px 35px',
        backgroundColor: Colors.white,
      }}
    >
      <h1
        className="global_font f-dark"
        style={{
          fontSize: 24,
          fontWeight: 'bold',
          marginTop: 45,
          marginBottom: 30,
          textAlign: 'center',
        }}
      >
        Challenges
      </h1>

      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          marginBlockEnd: 117,
          minHeight: 500,
        }}
      >
        <Table
          keyField="properks.id"
          columns={getColumn()}
          data={data}
          noDataComponent="No Properks Data"
          isLoading={isLoading}
          forceLoading={isLoading}
          showColumnsToHide={false}
          showTotal
          customStyles={{
            headCells: {
              style: {
                fontSize: 13,
                fontWeight: 'bold',
                width: '100%',
              },
            },
            rows: {
              style: {
                minHeight: '44px',
              },
            },
          }}
          paginationPerPage={ROWS_PER_PAGE}
          paginationTotalRows={total}
          totalPages={totalPages}
          onPageChange={handleTableChange}
          conditionalRowStyles={properksChallengeConditionalRowStyles}
          CustomHeaderComponent={() => (
            <div
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginRight: 25,
                marginLeft: 10,
                gap: 10,
              }}
            >
              <div>{showFilterStatus()}</div>
              <div style={{ display: 'flex', gap: 16 }}>
                <LegendItem color={Colors.background_60} text="Active" />
                <LegendItem color={Colors.neutral_100} text="Inactive" />
              </div>
            </div>
          )}
        />
      </div>
      {renderDeleteChallengePopup()}
    </div>
  );
};

export const LegendItem = ({ color, text }) => (
  <div style={{ display: 'flex', gap: 4, alignItems: 'center', color: Colors.neutral_500 }}>
    <div style={{ backgroundColor: color, height: 16, width: 16, borderRadius: 8 }} />
    <span>{text}</span>
  </div>
);
